/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface FileTypeSummary { 
    fileType?: FileTypeSummary.FileTypeEnum;
    count?: number;
    size?: number;
}
export namespace FileTypeSummary {
    export type FileTypeEnum = 'FOLDER' | 'PDF' | 'IFC' | 'EXCEL' | 'POWERPOINT' | 'WORD' | 'UNKNOWN' | 'COORDINATION';
    export const FileTypeEnum = {
        FOLDER: 'FOLDER' as FileTypeEnum,
        PDF: 'PDF' as FileTypeEnum,
        IFC: 'IFC' as FileTypeEnum,
        EXCEL: 'EXCEL' as FileTypeEnum,
        POWERPOINT: 'POWERPOINT' as FileTypeEnum,
        WORD: 'WORD' as FileTypeEnum,
        UNKNOWN: 'UNKNOWN' as FileTypeEnum,
        COORDINATION: 'COORDINATION' as FileTypeEnum
    };
}